'use client';

import { ReactNode } from 'react';
import { AutoTextSize } from 'auto-text-size';

interface TextAutoSizeProps {
  mode?: 'oneline' | 'multiline' | 'box' | 'boxoneline';
  minFontSizePx?: number;
  maxFontSizePx?: number;
  fontSizePrecisionPx?: number;
  as?: keyof React.JSX.IntrinsicElements | React.ComponentType<any>;
  children: ReactNode;
}

export default function TextAutoSize({
  mode = 'multiline',
  minFontSizePx = 8,
  maxFontSizePx = 160,
  fontSizePrecisionPx = 0.1,
  as = 'div',
  children
}: TextAutoSizeProps) {
  return (
    <AutoTextSize
      mode={mode}
      minFontSizePx={minFontSizePx}
      maxFontSizePx={maxFontSizePx}
      fontSizePrecisionPx={fontSizePrecisionPx}
      as={as}
      className="leading-none"
    >
      {children}
    </AutoTextSize>
  );
}
